module.exports = __webpack_public_path__ + "img/1121945914.968038af.png";